<template>
  <div class="profile-grid">
    <el-card class="profile-section" shadow="never">
      <div slot="header" class="section-heading"><i class="el-icon-user"></i><strong>账号资料</strong></div>
      <el-form ref="infoForm" :model="userInfo" :rules="rules" label-position="top" size="small" @submit.native.prevent="updateUserInfo">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="userInfo.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="QQ 号码" prop="qqNumber">
          <el-input v-model.trim="userInfo.qqNumber" placeholder="请输入 QQ 号码" inputmode="numeric" maxlength="15"></el-input>
        </el-form-item>
        <div class="section-actions"><el-button type="primary" size="small" native-type="submit">保存资料</el-button></div>
      </el-form>
    </el-card>

    <el-card class="profile-section avatar-section" shadow="never">
      <div slot="header" class="section-heading"><i class="el-icon-picture-outline"></i><strong>头像</strong></div>
      <div class="avatar-content">
        <el-upload
          ref="upload"
          class="avatar-uploader"
          action="/api/user/avatar"
          accept="image/png,image/jpeg"
          :headers="header"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="onAvatarChange"
          :before-upload="validateAvatar"
          :on-success="onSuccess"
          :limit="1"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" alt="当前头像">
          <i v-else class="el-icon-plus avatar-placeholder"></i>
        </el-upload>
        <p>支持 JPG、PNG，大小不超过 2 MB</p>
        <el-button type="primary" size="small" plain @click="uploadAvatar">上传头像</el-button>
      </div>
    </el-card>

    <el-card class="profile-section password-section" shadow="never">
      <div slot="header" class="section-heading"><i class="el-icon-lock"></i><strong>修改密码</strong></div>
      <el-form :model="passwords" label-position="top" size="small" @submit.native.prevent="updateUserPassword">
        <el-form-item label="当前密码">
          <el-input v-model="passwords.oldPassword" type="password" autocomplete="current-password" show-password placeholder="输入当前密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwords.newPassword" type="password" autocomplete="new-password" show-password placeholder="输入新密码"></el-input>
        </el-form-item>
        <div class="section-actions"><el-button type="primary" size="small" native-type="submit">更新密码</el-button></div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'
import { EventBus } from '@/EventBus'

export default {
  name: 'UserInfo',
  data() {
    return {
      userInfo: { username: '', qqNumber: '' },
      passwords: { oldPassword: '', newPassword: '' },
      rules: {
        qqNumber: [
          { required: true, message: '请输入 QQ 号码', trigger: 'blur' },
          { pattern: /^[1-9][0-9]{4,14}$/, message: '请输入正确的 QQ 号码', trigger: 'blur' }
        ]
      },
      imageUrl: '',
      objectUrl: ''
    }
  },
  computed: {
    header() { return { Authorization: 'Bearer ' + localStorage.getItem('token') } }
  },
  mounted() {
    this.getUserInfo()
    this.getAvatar()
  },
  beforeDestroy() { if (this.objectUrl) URL.revokeObjectURL(this.objectUrl) },
  methods: {
    setImage(blob) {
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
      this.objectUrl = URL.createObjectURL(blob)
      this.imageUrl = this.objectUrl
    },
    async getUserInfo() {
      try {
        const res = await axios.get('/api/user/info', { headers: this.header })
        if (res.data.code === 200) this.userInfo = res.data.data
        else this.$message.error(res.data.message || '加载个人资料失败')
      } catch (error) { this.$message.error('加载个人资料失败') }
    },
    async getAvatar() {
      try {
        const res = await axios.get('/api/user/avatar', { headers: this.header, responseType: 'blob' })
        this.setImage(res.data)
      } catch (error) { this.imageUrl = '' }
    },
    updateUserInfo() {
      this.$refs.infoForm.validate(async valid => {
        if (!valid) return
        try {
          const res = await axios.post('/api/user/info', this.userInfo, { headers: this.header })
          if (res.data.code === 200) {
            this.$message.success('个人资料已更新')
            this.getUserInfo()
          } else this.$message.error(res.data.message || '保存失败')
        } catch (error) { this.$message.error('保存失败') }
      })
    },
    async updateUserPassword() {
      if (!this.passwords.oldPassword || !this.passwords.newPassword) {
        this.$message.warning('请输入当前密码和新密码')
        return
      }
      try {
        const res = await axios.post('/api/user/password', this.passwords, { headers: this.header })
        if (res.data.code === 200) {
          this.passwords = { oldPassword: '', newPassword: '' }
          this.$message.success('密码已更新，请重新登录')
          localStorage.removeItem('token')
          EventBus.$emit('changeState')
          this.$router.push('/login')
        } else this.$message.error(res.data.message || '修改密码失败')
      } catch (error) { this.$message.error('修改密码失败') }
    },
    validateAvatar(file) {
      const validType = ['image/jpeg', 'image/png'].includes(file.type)
      const validSize = file.size < 2 * 1024 * 1024
      if (!validType) this.$message.error('头像只能使用 JPG 或 PNG 格式')
      else if (!validSize) this.$message.error('头像不能超过 2 MB')
      return validType && validSize
    },
    onAvatarChange(file) {
      if (this.validateAvatar(file.raw)) this.setImage(file.raw)
      else this.$refs.upload.clearFiles()
    },
    onSuccess(response) {
      if (response.code === 200) {
        this.$message.success('头像已更新')
        this.$refs.upload.clearFiles()
        EventBus.$emit('changeState')
      } else this.$message.error(response.message || '上传头像失败')
    },
    uploadAvatar() {
      if (!this.$refs.upload.uploadFiles.length) {
        this.$message.info('请先选择头像')
        return
      }
      this.$refs.upload.submit()
    }
  }
}
</script>

<style scoped>
.profile-grid { display: grid; grid-template-columns: minmax(0, 1.5fr) minmax(230px, 1fr); gap: 14px; align-items: start; }
.profile-section { border: 1px solid rgba(220, 223, 230, .8); border-radius: 12px; background: rgba(255, 255, 255, .48); }
.profile-section >>> .el-card__header { padding: 14px 16px; border-bottom-color: rgba(220, 223, 230, .7); }
.profile-section >>> .el-card__body { padding: 16px; }
.section-heading { display: flex; align-items: center; gap: 9px; color: #303133; font-size: 14px; }
.section-heading i { color: #409eff; font-size: 17px; }
.profile-section >>> .el-form-item { margin-bottom: 15px; }
.profile-section >>> .el-form-item__label { padding-bottom: 3px; line-height: 18px; color: #606266; font-size: 12px; }
.profile-section >>> .el-input__inner { background: rgba(255, 255, 255, .58); }
.section-actions { display: flex; justify-content: flex-end; }
.avatar-content { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; }
.avatar-uploader >>> .el-upload { display: grid; place-items: center; width: 112px; height: 112px; overflow: hidden; border: 1px dashed #c0c4cc; border-radius: 12px; cursor: pointer; }
.avatar-uploader >>> .el-upload:hover { border-color: #409eff; }
.avatar { display: block; width: 100%; height: 100%; object-fit: cover; }
.avatar-placeholder { color: #909399; font-size: 25px; }
.avatar-content p { margin: 0; color: #909399; font-size: 11px; }
.password-section { grid-column: 1 / -1; }
.password-section >>> .el-form { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 14px; }
.password-section .section-actions { grid-column: 1 / -1; }
@media (max-width: 900px) { .profile-grid { grid-template-columns: 1fr; } .password-section { grid-column: auto; } }
@media (max-width: 560px) { .password-section >>> .el-form { display: block; } }
</style>
